export const selectDolls = state => state.rightDoll.dolls;
export const selectSaveError = state => state.rightDoll.saveError;
export const selectLoading = state => state.rightDoll.dollsLoading;
export const selectTitleLevel = state => state.rightDoll.titleLevel;
export const selectDegreeLevel = state => state.rightDoll.degreeLevel;
export const selectTitleGreatness = state => state.rightDoll.titleGreatness;
export const selectDegreeGreatness = state => state.rightDoll.degreeGreatness;
export const selectStrength = state => state.rightDoll.strength;
export const selectDexterity = state => state.rightDoll.dexterity;
export const selectAccuracy = state => state.rightDoll.accuracy;
export const selectEndurance = state => state.rightDoll.endurance;
export const selectEarth = state => state.rightDoll.earth;
export const selectAir = state => state.rightDoll.air;
export const selectWater = state => state.rightDoll.water;
export const selectFire = state => state.rightDoll.fire;
export const selectStrengthStats = state => state.rightDoll.strengthStats;
export const selectDexterityStats = state => state.rightDoll.dexterityStats;
export const selectAccuracyStats = state => state.rightDoll.accuracyStats;
export const selectEnduranceStats = state => state.rightDoll.enduranceStats;
export const selectEarthStats = state => state.rightDoll.earthStats;
export const selectAirStats = state => state.rightDoll.airStats;
export const selectWaterStats = state => state.rightDoll.waterStats;
export const selectFireStats = state => state.rightDoll.fireStats;
export const selectHPStats = state => state.rightDoll.hpStats;
export const selectPranaStats = state => state.rightDoll.pranaStats;
export const selectHP = state => state.rightDoll.hp;
export const selectPrana = state => state.rightDoll.prana;
export const selectPDStats = state => state.rightDoll.pdStats;
export const selectMDStats = state => state.rightDoll.mdStats;
export const selectPAStats = state => state.rightDoll.paStats;
export const selectMAStats = state => state.rightDoll.maStats;
export const selectTitleStats = state => state.rightDoll.titleStats;
export const selectDegreeStats = state => state.rightDoll.degreeStats;
export const selectHelmet = state => state.rightDoll.helmet;
export const selectAmulet = state => state.rightDoll.amulet;
export const selectGloves = state => state.rightDoll.gloves;
export const selectJacket = state => state.rightDoll.jacket;
export const selectShield = state => state.rightDoll.shield;
export const selectBracelet1 = state => state.rightDoll.bracelet1;
export const selectBracelet2 = state => state.rightDoll.bracelet2;
export const selectBelt = state => state.rightDoll.belt;
export const selectRing1 = state => state.rightDoll.ring1;
export const selectRing2 = state => state.rightDoll.ring2;
export const selectRing3 = state => state.rightDoll.ring3;
export const selectRing4 = state => state.rightDoll.ring4;
export const selectPants = state => state.rightDoll.pants;
export const selectBoots = state => state.rightDoll.boots;
export const selectWeapon = state => state.rightDoll.weapon;
export const selectProfession = state => state.rightDoll.profession;
export const selectBuff1 = state => state.rightDoll.buff1;
export const selectBuff2 = state => state.rightDoll.buff2;
export const selectBuff3 = state => state.rightDoll.buff3;
export const selectBuff4 = state => state.rightDoll.buff4;
export const selectBuff5 = state => state.rightDoll.buff5;
export const selectBuff6 = state => state.rightDoll.buff6;
export const selectBuff7 = state => state.rightDoll.buff7;
export const selectBuff8 = state => state.rightDoll.buff8;
export const selectBuff9 = state => state.rightDoll.buff9;
export const selectBuff10 = state => state.rightDoll.buff10;
export const selectCrystalPD = state => state.rightDoll.crystalpd;
export const selectCrystalMD = state => state.rightDoll.crystalmd;
export const selectCrystalPA = state => state.rightDoll.crystalpa;
export const selectCrystalMA = state => state.rightDoll.crystalma;
export const selectSlot1 = state => state.rightDoll.slot1;
export const selectSlot2 = state => state.rightDoll.slot2;
export const selectSlot3 = state => state.rightDoll.slot3;
export const selectSlot4 = state => state.rightDoll.slot4;
export const selectSlot5 = state => state.rightDoll.slot5;
export const selectSlot6 = state => state.rightDoll.slot6;
export const selectSlot7 = state => state.rightDoll.slot7;
export const selectSlot8 = state => state.rightDoll.slot8;
export const selectSlot9 = state => state.rightDoll.slot9;
export const selectSlot10 = state => state.rightDoll.slot10;
export const selectReqProfession = state => state.rightDoll.reqProfession;
export const selectReqProfessionLevel = state => state.rightDoll.reqProfessionLevel;
export const selectReqStrength = state => state.rightDoll.reqStrength;
export const selectReqDexterity = state => state.rightDoll.reqDexterity;
export const selectReqAccuracy = state => state.rightDoll.reqAccuracy;
export const selectReqEndurance = state => state.rightDoll.reqEndurance;
export const selectReqEarth = state => state.rightDoll.reqEarth;
export const selectReqAir = state => state.rightDoll.reqAir;
export const selectReqWater = state => state.rightDoll.reqWater;
export const selectReqFire = state => state.rightDoll.reqFire;
export const selectPrefixes = state => state.rightDoll.prefixes;
export const selectOtherDoll = state => state.rightDoll.otherDoll;
export const selectOtherDolls = state => state.rightDoll.otherDolls;
export const selectDefaultDolls = state => state.rightDoll.defaultDolls;
export const selectDoll = state => state.rightDoll.doll;
export const selectDollError = state => state.rightDoll.dollError;
export const selectDollName = state => state.rightDoll.dollName;
export const selectDollDetailsLoading = state => state.rightDoll.dollDetailsLoading;